import styles from './Card.module.css'

interface CardProps {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  variant?: 'default' | 'done'
  'data-testid'?: string
}

export default function Card({
  children,
  className,
  onClick,
  variant = 'default',
  'data-testid': testId,
}: CardProps) {
  return (
    <div
      data-testid={testId}
      className={[
        styles.card,
        variant === 'done' && styles.done,
        onClick && styles.interactive,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') onClick()
            }
          : undefined
      }
    >
      {children}
    </div>
  )
}
